enum TaskCategories {
  MANDATORY = 'mandatory',
  RECOMMENDED = 'recommended',
  SHARED = 'shared'
}

export default TaskCategories
